import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { createUser, createdUser, updateUser, updatedUser, deleteUser, deletedUser } from './actions';

import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  errorType: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(createUser, (state) => {
      state.status = 'loading';
    })
    .addCase(createdUser, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(updateUser, (state) => {
      state.status = 'loading';
    })
    .addCase(updatedUser, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as State['data'];
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(deleteUser, (state) => {
      state.status = 'loading';
    })
    .addCase(deletedUser, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
        state.errorType = 'delete';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'User') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
